import { render, staticRenderFns } from "./DataAnalysisElaborazioniBatchListComponent.vue?vue&type=template&id=08789819"
import script from "./DataAnalysisElaborazioniBatchListComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisElaborazioniBatchListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports